import styled from "styled-components";

interface iIsOpenSideMenu {
  isOpen?: boolean;
}

export const Container = styled.aside<iIsOpenSideMenu>`
  display: flex;
  overflow: auto;

  position: fixed;
  top: 0;
  bottom: 0;
  left: ${(props) => (props.isOpen ? 0 : `-100vw `)};
  width: 100vw;
  background: rgb(33, 33, 33);

  transition: left 0.5s ease-in-out;
  z-index: 2;

  button {
    cursor: pointer;
  }
  label {
    color: #ffff;
  }

  flex-direction: column;

  @media (min-width: 768px) {
    display: grid;
    grid-template-areas:
      "header"
      "main"
      "footer";

    display: inherit;
    position: absolute;
    width: 100% !important;
    height: auto;
    top: 49px;
    left: 0;
    bottom: auto;
    background-color: ${(props) => props.theme.colors.brand4.pure};
    transition: max-height 4s;
    padding: 20px 0 0 0;
    max-height: 62vh;
  }
  ::-webkit-scrollbar {
    width: 8px;
    background-color: ${(props) => props.theme.colors.brand4.dark};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.brand1.pure};
  }
`;

export const FilterOptions = styled.main`
  grid-area: main;
  padding: 8px 20px 200px 20px;

  @media (min-width: 768px) {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
    align-items: start;
    margin: 0;
    padding: 0;
  }
`;

export const Contente = styled.div`
  margin-bottom: 20px;
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral2.light};

  @media (min-width: 768px) {
    border: none;
    margin: 0;
  }
`;

export const ButtonTitle = styled.div`
  @media (max-width: 767px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
`;
